import Button from "@mui/material/Button";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Link } from "react-router-dom";
import LandingSectionHeader from "./LandingSectionHeader";
import {
  PRICING_SECTION,
  PRICING_TIER_COMPARISON,
  MEDIA_STORAGE_SECTION,
} from "../content/pricing";
import "./LandingPricingSection.css";

function formatPrice(value) {
  return new Intl.NumberFormat("ru-RU").format(value);
}

function LandingTierComparisonTable({ columns, rows }) {
  return (
    <div className="landing-pricing-table-wrap">
      <table className="landing-pricing-table">
        <thead>
          <tr>
            <th scope="col">Возможность</th>
            {columns.map((column) => (
              <th
                key={column.id}
                scope="col"
                className={
                  column.highlight ? "landing-pricing-table__col--featured" : ""
                }
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.label}>
              <th scope="row">{row.label}</th>
              {row.values.map((value, index) => (
                <td
                  key={`${row.label}-${columns[index].id}`}
                  className={
                    columns[index].highlight
                      ? "landing-pricing-table__col--featured"
                      : ""
                  }
                >
                  {value === "check" ? (
                    <span
                      className="landing-pricing-table__check"
                      aria-label="Включено"
                    >
                      ✓
                    </span>
                  ) : (
                    value
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function LandingPricingSection() {
  const mediaFromPrice = MEDIA_STORAGE_SECTION.plans[0]?.price ?? 790;

  return (
    <section
      id="pricing"
      className="landing-band landing-band--pricing landing-section landing-section--pricing"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="05 · Тарифы"
          title="Прозрачные цены — без сюрпризов"
          desc="Сразу видно, сколько стоит доступ для команды. После регистрации автоматически включается 14 дней триала — можно опубликовать проект и открыть доступ сотрудникам."
        />

        <div className="landing-band__panel landing-band__panel--pricing">
          <article className="landing-pricing-trial">
            <div className="landing-pricing-trial__row">
              <span className="landing-pricing-trial__badge">14 дней бесплатно</span>
              <h3 className="landing-pricing-trial__title">
                Триал «Микрокоманда»
              </h3>
            </div>
            <p className="landing-pricing-trial__desc">
              Полный доступ к публикации и команде до 15 человек. Без карты и
              автопродления.
            </p>
            <ul className="landing-pricing-trial__features">
              <li>
                <CheckCircleOutlineIcon fontSize="small" aria-hidden />
                База знаний, сценарии, тренажёр
              </li>
              <li>
                <CheckCircleOutlineIcon fontSize="small" aria-hidden />
                Telegram и MAX
              </li>
              <li>
                <CheckCircleOutlineIcon fontSize="small" aria-hidden />
                10 ГБ для видео
              </li>
            </ul>
            <Link to="/login?tab=register" className="landing-pricing-trial__cta">
              <Button
                variant="contained"
                size="large"
                className="landing-pricing-trial__btn"
              >
                Начать триал бесплатно
              </Button>
            </Link>
          </article>

          <div className="landing-pricing-plans">
            <p className="landing-pricing-plans__lead">
              Платные тарифы после триала — оплата без автосписания
            </p>
            <div className="landing-pricing-grid">
              {PRICING_SECTION.plans.map((plan) => (
                <article
                  key={plan.packageId}
                  className={`landing-pricing-card${
                    plan.highlight ? " landing-pricing-card--featured" : ""
                  }${plan.packageId === "biz_s_15" ? " landing-pricing-card--trial-plan" : ""}`}
                >
                  {plan.packageId === "biz_s_15" || plan.highlight ? (
                    <div className="landing-pricing-card__tags">
                      {plan.packageId === "biz_s_15" ? (
                        <span className="landing-pricing-card__tag landing-pricing-card__tag--trial">
                          Включено в триал
                        </span>
                      ) : null}
                      {plan.highlight ? (
                        <span className="landing-pricing-card__tag">Популярный</span>
                      ) : null}
                    </div>
                  ) : null}
                  {plan.tierName ? (
                    <span className="landing-pricing-card__tier">{plan.tierName}</span>
                  ) : null}
                  <h4 className="landing-pricing-card__title">{plan.title}</h4>
                  {plan.segmentLabel ? (
                    <p className="landing-pricing-card__segment">{plan.segmentLabel}</p>
                  ) : null}
                  <div className="landing-pricing-card__price">
                    {formatPrice(plan.price)} &#8381;
                    {plan.pricePeriod ? (
                      <span className="landing-pricing-card__period">
                        {plan.pricePeriod}
                      </span>
                    ) : null}
                  </div>
                  <p className="landing-pricing-card__meta">{plan.perUnit}</p>
                  <ul className="landing-pricing-card__features">
                    {plan.features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </div>

          <div className="landing-pricing-comparison">
            <h3 className="landing-pricing-comparison__title">
              {PRICING_TIER_COMPARISON.title}
            </h3>
            <p className="landing-pricing-comparison__desc">
              {PRICING_TIER_COMPARISON.subtitle}
            </p>
            <LandingTierComparisonTable
              columns={PRICING_TIER_COMPARISON.columns}
              rows={PRICING_TIER_COMPARISON.rows}
            />
          </div>

          <aside className="landing-pricing-extra">
            <h4 className="landing-pricing-extra__title">
              {MEDIA_STORAGE_SECTION.title}
            </h4>
            <p className="landing-pricing-extra__desc">
              {MEDIA_STORAGE_SECTION.subtitle} Пакеты от {formatPrice(mediaFromPrice)}{" "}
              &#8381; — докупаются при необходимости, не обязательны для старта.
            </p>
            <div className="landing-pricing-extra__chips">
              {MEDIA_STORAGE_SECTION.plans.map((plan) => (
                <span key={plan.packageId} className="landing-pricing-extra__chip">
                  {plan.title} — {formatPrice(plan.price)} &#8381;
                </span>
              ))}
            </div>
          </aside>

          <div className="landing-pricing-footer-cta">
            <p className="landing-pricing-footer-cta__text">
              Попробуйте InChat с командой — триал на 14 дней уже включён в
              регистрацию
            </p>
            <div className="landing-pricing-footer-cta__actions">
              <Link to="/login?tab=register">
                <Button
                  variant="contained"
                  size="large"
                  className="landing-pricing-footer-cta__btn-primary"
                >
                  Зарегистрироваться
                </Button>
              </Link>
              <Link to="/login">
                <Button
                  variant="outlined"
                  size="large"
                  className="landing-pricing-footer-cta__btn-secondary"
                >
                  Уже есть аккаунт
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
